import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
const resources = {
  en:{
    "translation": {
        "landing":{
          "title":"Wellbe",
          "description":"Elevate Your Well-being with Premium Content, Expert Guidance, and AI-Powered Insights"
        },
        "nav": {
          "sign_out": "Sign Out",
          "sign_in": "Join Now",
          "CalculateIBW":"Wellbe Ai",
          "about":'About',
          "categories":"Videos",
          "keyfigures":"Key Figures",
          "mycoach":"My Coach",
          "dailyplan":"Daily Plan"
        },
        "about":{
            "title":"About Wellbe",
            "description":"Wellbe is your go-to destination for premium content designed to enhance your well-being. Fueled by AI-powered insights, backed by expert guidance and grounded in scientific research, our platform offers a variety of engaging and visually appealing resources ",
            "card-1-desc":"Life-transforming programs, Top Experts, Proven Results",
            "card-2-desc":"High Quality Videos, Multilingual Content, Premium Production"
        },
        "articles":{
           "title":"Key Figures",
            "card-1-title":"Stress Reduction",
            "card-1-desc":"Articipants Reported A Noticeable Decrease In Stress Levels After Incorporating Our Mindfulness And Meditation Videos Into Their Routine",
            "card-2-title":"Physical Fitness",
            "card-2-desc":"Engaging In Our Fitness And Yoga Videos Resulted In A 64% Increase In Reported Physical Fitness Levels Among Participants",
            "card-3-title":"Improved Sleep Quality",
            "card-3-desc":"Our Sleep-Focused Videos Contributed To 72% Of Members Reporting Better Sleep Quality, Leading To Increased Overall Well-Being",
            "card-4-title":"Mental Well-Being",
            "card-4-desc":"Over 80% Of Our Community Members Reported Enhanced Mental Well-Being, Citing Improved Focus, Clarity, And Emotional Balance",
        },
        "categories":{
            "title":"Our Categories And Videos",
            "health":"health",
            "performance":"performance",
            "meditation":"meditation",
            "nutrition":"nutrition",
            "yoga":"yoga",  
        },
        "video":{
         "video-not-found":"Video Not Available For Demo !",
        },
        "custommodal":{
          "phonelabel":"Enter your phone number",
          "not_subscriber":"Not a Subscriber?",
          "Subscribe":'Subscribe',
          "otplabel":"Enter OTP",
          "Verify":"Verify",
        },
        "bodyweight":{
          "title": "Wellbe Ai",
          "text": "Track Your Body and Health Metrics",
          "Weight/Kg":"Weight/Kg",
          "Height/CM":"Height/CM",
          "Age":"Age",
          "Waist":"Waist/CM",
          "Hips":"Hips/CM",
          "Hours":"Hours",
          "Video":"Video",
          "Health":"Health",
          "Meditation":"Meditation",
          "Nutrition":"Nutrition",
          "Performance":"Performance",
          "Yoga":"Yoga",
          "WatchVideo":"Watch Video",
          "Waistdef":"Measure (cm) around the narrowest part of your waist, just above your belly button.",
          "Hipsdef":"Measure around the widest part of your hips and buttocks.",
          "personform":{
            "label":"Enter Your Details",
            "activitylable":"Activity Level",
            "activity":{
              "sedentary":"Sedentary",
              "light":"Light",
              "moderate":"Moderate",
              "active":"Active",
            },
            "stresslable":"Stress Level",
            "stress":{
             "low":"Low",
              "high":"High",
            },
            "male":"Male",
            "female":"Female",
            "dietarylable":"Dietary Preferences",
            "dietaryoptions":{
              "None":"None",
              "Vegetarian":"Vegetarian",
              "Vegan":"Vegan",
              "Gluten-free":"Gluten-free",
              "Dairy-free":"Dairy-free",
              "Paleo":"Paleo",
              "Keto":"Keto",
              "Low-carb":"Low-carb",
              "Low-fat":"Low-fat",
              "Other":"Other"
            },
            "sleepinghours":"Sleeping Hours",
            "goals":"Weight Goals",
             "goalsoptions":{
               "loss":"Lose",
               "maintain":"Maintain",
               "gain":"Gain",
             },
             "calculate":"Calculate",
          },
          "youresult":"Your Results",
          "kg":"Kg",
          "resulttext":"Ideal body weight",
          "inkg":"in kg",
          "bmrdesc":'Basal metabolic rate',
          "MACRONUTRIENTS":"The Ideal Macronutrients %",
          "Carbohydrates":"Carbohydrates",
          "Fat":"Fat",
          "Protein":"Protein",
          "water":"Water",
          "Guidelines":"Guidelines",
          "Fitness_Exercises":"Fitness Exercises",
          "Nutritional_Recommendations":"Nutritional Recommendations",
          "Hydration":"Hydration",
          "Sleep_Recovery":"Sleep and Recovery",
          "Stress_Management":"Stress Management",
          "Movement_Incorporation":"Movement Incorporation",
          "Wellness_Habits":"Wellness Habits",
          "PleaseFill":"Please Fill",
          "PleaseChoose":"Please Choose",
          "Day":"Day",
          "Apple":"Apple",
          "Pear":"Pear",
          "Hourglass":"Hourglass",
          "Normal":"Normal",
          "Underweight":"Underweight",
          "Overweight":"Overweight",
        },
        "chatbot":{
          "avatartitle":'Meet Your Avatar Coach !',
          "avatardesc":'Customize your avatar and unlock intelligent health guidance through an AI-powered chatbot designed to be your personal coach.',
          "chat":'Chat',
          "create":"Create",
          "name":"Name...",
          "edit":"Edit",
          "NEXT":"NEXT",
          "overlayText":"Congratulations! You Have Created Your Own Coach.",
          "inittext1":"Tap the arrow and step into the spotlight",
          "inittext2":"Your Personal Coach Journey Begins Now!"

        },
        "footer":{
            "title":"Questions or Clarifications? Email Us!",
             "desc":"For inquiries, assistance, or any clarifications, please don't hesitate to reach out to us via email. Wellbe team is here to support you on your journey",
             "submit":"Submit",
             "copyright":"Copyright© Welbe. All rights reserved",
             "FAQ":"FAQ",
             "Blog":"Blog",
             "terms":"Terms & Conditions",
             "emailPlaceholder": "Email:",
             "messagePlaceholder": "Message",
             "invalidemail":"Invalid email format",
             "unsubscribe":"Unsubscribe",
        },
        "incorrect": "Incorrect",
        "terms":{
          "title":"Terms & Conditions",
          "text":"If you have any medical conditions or are thinking about starting an exercise program or engaging in strenuous or unusual physical or mental activity, you should consult your doctor first. WITHOUT LIMITATION OF ANY OTHER TERMS IN THIS TERMS OF SERVICE, WELLBE PRIME DOES NOT MAKE ANY REPRESENTATIONS OR WARRANTIES THAT THE VIDEOS ARE INTENDED TO AND/OR DOES DIAGNOSE, TREAT, CURE, OR PREVENT ANY ALLERGIES OR OTHER MEDICAL DISORDERS OR CONDITIONS, AND YOU HEREBY ACKNOWLEDGE THIS DISCLAIMER AND THAT WELLBE PRIME IS NOT ENGAGED IN PROVIDING YOU WITH A MEDICAL DEVICE, MEDICAL ADVICE AND/OR HEALTHCARE SERVICES BY PROVIDING YOU WITH ACCESS TO THE VIDEOS. You should consult with a licensed medical or fitness professional if you have any questions regarding your physical fitness or mental health routine. Wellbe Prime is not responsible in any way for any health problems or injuries, including, without limitation, incapacity or death, which may result from or be related to your use of or inability to use the Videos. Wellbe Prime is not a health care or medical device provider, nor should Caravan's Videos be considered medical advice. Wellbe Prime makes no claims, representations or guarantees that the Videos provide a therapeutic benefit. Any health information and links related to the Videos are provided simply for your convenience. Any advice or other materials in the Videos are intended for general information purposes only. They are not intended to be relied upon and are not a substitute for professional medical or mental advice based on your individual condition and circumstances. The advice and other materials Wellbe Prime makes available are intended to support the relationship between you and your healthcare providers and not replace it. Wellbe Prime is not liable or responsible for any consequences of your having read or been told about such advice or other materials as you assume full responsibility for your decisions and actions. In particular, to the fullest extent permitted by law, Wellbe Prime makes no representation or warranties about the accuracy, completeness, or suitability for any purpose of the information published as part of the Videos."
        }
      }
  },
  ar:{
    "translation": {
        "landing": {
            "title": "Wellbe",
            "description": "ارفع مستوى صحتك بمحتوى متميز، إرشادات خبراء متخصصين، وتحليلات مدعومة بالذكاء الاصطناعي"
        },
        "nav": {
          "sign_out": "تسجيل الخروج",
          "sign_in": "انضم الآن",
          "CalculateIBW":"Wellbe Ai",
          "about": "عن الخدمة",
          "categories": "فيديوهات",
          "keyfigures": " إحصائيات",
          "mycoach": "مدربي",
          "dailyplan": "الخطة اليومية"
        },
        "about": {
            "title": "Wellbe عن ",
            "description": "Wellbe هي وجهتك الرئيسية للمحتوى المتميز الذي يهدف إلى تعزيز رفاهيتك. بفضل تحليلات الذكاء الاصطناعي، وبدعم من إرشادات الخبراء ومبنية على الأبحاث العلمية، تقدم منصتنا مجموعة متنوعة من الموارد الشيقة والجذابة بصرياً",
            "card-1-desc": "برامج تحول الحياة، خبراء متميزون، نتائج مثبتة",
            "card-2-desc": "مقاطع فيديو عالية الجودة، محتوى متعدد اللغات، إنتاج ممتاز"
        },
        "articles": {
            "title": "الأرقام الرئيسية",
            "card-1-title": "تقليل التوتر",
            "card-1-desc": "أبلغ المشاركون عن انخفاض ملحوظ في مستويات التوتر بعد دمج مقاطع الفيديو الخاصة بالاسترخاء والتأمل في روتينهم اليومي",
            "card-2-title": "اللياقة البدنية",
            "card-2-desc": "أدى مشاركتهم في مقاطع الفيديو الخاصة باللياقة البدنية واليوغا إلى زيادة بنسبة 64% في مستويات اللياقة البدنية المبلغ عنها بين المشاركين",
            "card-3-title": "جودة النوم المحسنة",
            "card-3-desc": "ساهمت مقاطع الفيديو التي تركز على النوم في تحسين جودة النوم لدى 72% من الأعضاء، مما أدى إلى زيادة الرفاهية العامة",
            "card-4-title": "الرفاهية العقلية",
            "card-4-desc": "أبلغ أكثر من 80% من أعضاء مجتمعنا عن تحسين في الرفاهية العقلية، مشيرين إلى تحسين التركيز والوضوح والتوازن العاطفي"
        },
        "categories": {
            "title": "تصنيفاتنا ومقاطع الفيديو",
            "health": "الصحة",
            "performance": "الأداء",
            "meditation": "التأمل",
            "nutrition": "التغذية",
            "yoga": "اليوغا",
        },
        "video": {
            "video-not-found": "الفيديو غير متوفر للعرض!"
         },
        "custommodal": {
            "phonelabel": "أدخل رقم هاتفك",
            "not_subscriber": "لست مشتركاً؟",
            "Subscribe": "اشتراك",
            "otplabel": "أدخل رمز التحقق",
            "Verify": "تحقق"
        },
        "bodyweight": {
          "title": "Wellbe Ai",
          "text": "تابع مقاييس جسمك وصحتك",
          "Weight/Kg": "الوزن/كغ",
          "Height/CM": "الطول/سم",
          "Age": "العمر",
          "Waist": "الخصر/سم",
          "Hips": "الورك/سم",
          "Hours":"ساعات",
          "Video": "فيديو",
          "Health": "صحة",
          "Meditation": "تأمل",
          "Nutrition": "تغذية",
          "Performance": "أداء",
          "Yoga": "يوغا",
          "WatchVideo": "شاهد الفيديو",
          "Waistdef": "قِس (سم) حول أضيق جزء من خصرك، تمامًا فوق سرتك.",
          "Hipsdef": "قِس حول أعرض جزء من الوركين والمؤخرة.",
          "personform": {
            "label": "أدخل تفاصيلك",
            "activitylable": "مستوى النشاط",
            "activity": {
              "sedentary": " الخمولي",
              "light": " الخفيف",
              "moderate": " المتوسط",
              "active": " النشط",
            },
            "stresslable": "مستوى الضغط",
            "stress": {
              "low": " منخفض",
              "high": " مرتفع",
            },
            "male": "ذكر",
            "female": "أنثى",
            "dietarylable": "تفضيلات النظام الغذائي",
            "dietaryoptions": {
              "None": "لا شيء",
              "Vegetarian": "نباتي",
              "Vegan": "نباتي صرف",
              "Gluten-free": "خالي من الغلوتين",
              "Dairy-free": "خالي من الألبان",
              "Paleo": "نظام غذائي باليو",
              "Keto": "نظام غذائي كيتو",
              "Low-carb": "قليل الكربوهيدرات",
              "Low-fat": "قليل الدهون",
              "Other": "أخرى"
            },
            "sleepinghours": "ساعات النوم",
            "goals": "أهداف الوزن",
            "goalsoptions": {
              "loss": "فقدان",
              "maintain": "الحفاظ",
              "gain": "زيادة",
            },
            "calculate": "احسب",
          },
          "youresult": "نتائجك",
          "kg": "كغ",
          "resulttext": "الوزن المثالي للجسم",
          "inkg": "بالكيلوغرام",
          "MACRONUTRIENTS":"نسبة المكونات الغذائية المثالية %",
          "Carbohydrates": "الكربوهيدرات",
          "Fat": "الدهون",
          "Protein": "البروتين",
          "bmrdesc": "معدل الأيض الأساسي",
          "water": "الماء",
          "Guidelines": "الإرشادات",
          "Fitness_Exercises": "تمارين اللياقة",
          "Nutritional_Recommendations": "التوصيات الغذائية",
          "Hydration": "الترطيب",
          "Sleep_Recovery": "النوم والتعافي",
          "Stress_Management": "إدارة الضغط",
          "Movement_Incorporation": "دمج الحركة",
          "Wellness_Habits": "عادات العافية",
          "PleaseFill":"يرجى ملء",
          "PleaseChoose":"يرجى الاختيار",
          "Day" : "يوم",
          "Apple": "تفاحة",
          "Pear": "كمثرى",
          "Hourglass": "ساعة رملية",
          "Normal": "طبيعي",
          "Underweight": "نحيف",
          "Overweight": "زائد الوزن"
        },
        "chatbot": {
          "avatartitle": "قابل مدربك الشخصي!",
          "avatardesc": "خصص الصورة الرمزية الخاصة بك وفعّل الإرشاد الصحي الذكي من خلال روبوت محادثة مدعوم بالذكاء الاصطناعي ليكون مدربك الشخصي.",
          "chat": "دردشة",
          "create": "إنشاء",
          "name": "الاسم...",
          "edit": "تعديل",
          "NEXT": "التالي",
          "overlayText": "تهانينا! لقد أنشأت مدربك الخاص.",
          "inittext1": "اضغط على السهم وادخل دائرة الضوء",
          "inittext2": "رحلتك مع المدرب الشخصي تبدأ الآن!"
        },
        "footer":{
            "title":"هل لديك أسئلة أو توضيحات؟ اتصل بنا عبر البريد الإلكتروني!",
            "desc":"للاستفسارات، المساعدة، أو أي توضيحات، يرجى عدم التردد في الاتصال بنا عبر البريد الإلكتروني. فريق Welbe هنا لدعمك في رحلتك.",
            "submit":"إرسال",
            "copyright":"حقوق الطبع والنشر © Welbe. جميع الحقوق محفوظة",
            "FAQ":"الأسئلة الشائعة",
            "Blog":"المدونة",
            "terms":"الشروط والأحكام",
            "emailPlaceholder": "البريد الإلكتروني:",
            "messagePlaceholder": "رسالة",
            "invalidemail": " البريد الإلكتروني غير صالح",
            "unsubscribe": "إلغاء الاشتراك",
         },
         "incorrect": "غير صحيح",
         "terms":{
          "title":"الشروط والأحكام",
          "text":"إذا كانت لديك أية حالات طبية أو تفكر في بدء برنامج تمرين أو المشاركة في نشاط بدني أو عقلي مجهد أو غير عادي، يجب عليك استشارة طبيبك أولاً. دون قيد أو شرط لأي شروط أخرى في هذه الخدمة، لا تقدم WELLBE PRIME أية تمثيلات أو ضمانات بأن الفيديوهات تهدف و/أو تشخص أو تعالج أو تعالج أو تمنع أي حساسيات أو اضطرابات طبية أخرى، وأنت تقر بأن WELLBE PRIME لا تشارك في توفير جهاز طبي أو نصيحة طبية و/أو خدمات صحية لك من خلال توفير الوصول إلى الفيديوهات. يجب عليك استشارة متخصص طبي مرخص أو محترف في اللياقة البدنية إذا كانت لديك أية أسئلة بشأن لياقتك البدنية أو روتين صحتك العقلية. لا تتحمل Wellbe Prime مسؤولية أي مشاكل صحية أو إصابات بأي شكل من الأشكال، بما في ذلك، دون حصر، العجز أو الوفاة، التي قد تنتج عن استخدامك للفيديوهات أو عدم القدرة على استخدامها. لا تعتبر Wellbe Prime مقدمة لخدمات الرعاية الصحية أو الأجهزة الطبية، ولا يجب اعتبار فيديوهات Caravan نصيحة طبية. لا تدعي Wellbe Prime أن الفيديوهات توفر فائدة علاجية. تُقدم أية معلومات صحية وروابط متعلقة بالفيديوهات ببساطة لراحتك. تُقدم أية نصائح أو مواد أخرى في الفيديوهات لأغراض معلومات عامة فقط. لا تقصد أن تعتمد عليها ولا تُعتبر بديلاً عن النصيحة الطبية أو العقلية المهنية استنادًا إلى حالتك وظروفك الفردية. تهدف النصائح والمواد الأخرى التي يُقدمها Wellbe Prime إلى دعم العلاقة بينك وبين مقدمي الرعاية الصحية وليس استبدالها. لا تتحمل Wellbe Prime أي مسؤولية أو مسؤولية عن أية عواقب لقراءتك أو إخبارك بمثل هذه النصائح أو المواد الأخرى حيث تتحمل كامل المسؤولية عن قراراتك وأفعالك. بشكل خاص، وإلى أقصى حد مسموح به من القانون، لا تقدم Wellbe Prime أية تمثيلات أو ضمانات بشأن دقة أو اكتمال أو ملاءمة لأي غرض للمعلومات المنشورة كجزء من الفيديوهات."
        }
      }
  },
  fr:{
    "translation": {
        "landing": {
            "title": "Wellbe",
            "description": "Élevez votre bien-être avec un contenu premium, des conseils d'experts et des analyses alimentées par l'intelligence artificielle."
        },
        "nav": {
            "sign_out": "Se déconnecter",
            "sign_in": "Rejoindre maintenant",
            "CalculateIBW":"Wellbe Ai",
            "about": "À propos",
            "categories": "Vidéos",
            "keyfigures": "Chiffres clés",
            "mycoach": "Mon Coach",
            "dailyplan": "Plan quotidien"
          },
        "about": {
            "title": "À propos de Wellbe",
            "description": "Wellbe est votre destination de prédilection pour un contenu premium conçu pour améliorer votre bien-être. Alimentée par des insights issus de l'intelligence artificielle, appuyée par des conseils d'experts et ancrée dans la recherche scientifique, notre plateforme propose une variété de ressources engageantes et visuellement attrayantes",
            "card-1-desc": "Programmes transformateurs de vie, meilleurs experts, résultats prouvés",
            "card-2-desc": "Vidéos de haute qualité, contenu multilingue, production premium"
        },
        "articles": {
            "title": "Chiffres clés",
            "card-1-title": "Réduction du stress",
            "card-1-desc": "Les participants ont signalé une diminution notable de leur niveau de stress après avoir incorporé nos vidéos de pleine conscience et de méditation dans leur routine.",
            "card-2-title": "Condition physique",
            "card-2-desc": "S'engager dans nos vidéos de fitness et de yoga a entraîné une augmentation de 64% des niveaux de forme physique signalés par les participants.",
            "card-3-title": "Qualité du sommeil améliorée",
            "card-3-desc": "Nos vidéos axées sur le sommeil ont contribué à ce que 72% des membres signalent une meilleure qualité de sommeil, ce qui a conduit à une amélioration globale du bien-être.",
            "card-4-title": "Bien-être mental",
            "card-4-desc": "Plus de 80% des membres de notre communauté ont signalé un bien-être mental amélioré, citant une meilleure concentration, clarté et équilibre émotionnel."
        },
        "categories": {
            "title": "Nos catégories et vidéos",
            "health": "santé",
            "performance": "performance",
            "meditation": "méditation",
            "nutrition": "nutrition",
            "yoga": "yoga"
          },
          "video": {
              "video-not-found": "Vidéo non disponible pour la démo !"
          },
          "custommodal": {
              "phonelabel": "Entrez votre numéro de téléphone",
              "not_subscriber": "Pas encore abonné ?",
              "Subscribe": "S'abonner",
              "otplabel": "Entrez OTP",
              "Verify": "Vérifier"
          },
          "bodyweight": {
            "title": "Wellbe Ai",
            "text": "Suivez les indicateurs de votre corps et de votre santé",
            "Weight/Kg": "Poids/Kg",
            "Height/CM": "Taille/CM",
            "Age": "Âge",
            "Waist": "Taille/cm",
            "Hips": "Hanches/cm",
            "Hours": "Heures",
            "Video": "Vidéo",
            "Health": "Santé",
            "Meditation": "Méditation",
            "Nutrition": "Nutrition",
            "Performance": "Performance",
            "Yoga": "Yoga",
            "WatchVideo": "Regarder la vidéo",
            "Waistdef": "Mesurez (cm) autour de la partie la plus étroite de votre taille, juste au-dessus de votre nombril.",
            "Hipsdef": "Mesurez autour de la partie la plus large de vos hanches et de vos fesses.",
            "personform": {
                "label": "Entrez Vos Détails",
                "activitylable": "Niveau d'Activité",
                "activity": {
                    "sedentary": "Sédentaire",
                    "light": "Léger",
                    "moderate": "Modéré",
                    "active": "Actif"
                },
                "stresslable": "Niveau de Stress",
                "stress": {
                    "low": "Faible",
                    "high": "Élevé"
                },
                "male": "Homme",
                "female": "Femme",
                "dietarylable": "Préférences Alimentaires",
                "dietaryoptions": {
                    "None": "Aucune",
                    "Vegetarian": "Végétarien",
                    "Vegan": "Végétalien",
                    "Gluten-free": "Sans Gluten",
                    "Dairy-free": "Sans Produits Laitiers",
                    "Paleo": "Paléo",
                    "Keto": "Cétogène",
                    "Low-carb": "Faible en Glucides",
                    "Low-fat": "Faible en Matières Grasses",
                    "Other": "Autre"
                },
                "sleepinghours": "Heures de Sommeil",
                "goals": "Objectifs de Poids",
                "goalsoptions": {
                    "loss": "Perte",
                    "maintain": "Maintien",
                    "gain": "Prise"
                },
                "calculate": "Calculer",
            },
            "youresult": "Vos Résultats",
            "kg": "Kg",
            "resulttext": "Poids corporel idéal",
            "inkg": "en kg",
            "MACRONUTRIENTS": "Le Pourcentage de Macronutriments Idéal",
            "Carbohydrates": "Glucides",
            "Fat": "Matières Grasses",
            "Protein": "Protéines",
            "bmrdesc": "Taux métabolique de base",
            "water": "Eau",
            "Guidelines": "Directives",
            "Fitness_Exercises": "Exercices de Fitness",
            "Nutritional_Recommendations": "Recommandations Nutritionnelles",
            "Hydration": "Hydratation",
            "Sleep_Recovery": "Sommeil et Récupération",
            "Stress_Management": "Gestion du Stress",
            "Movement_Incorporation": "Incorporation du Mouvement",
            "Wellness_Habits": "Habitudes Bien-Être",
            "PLeaseFill": "Veuillez remplir",
            "PleaseChoose":"Veuillez choisir",
            "Day" : "Jour",
            "Apple": "Pomme",
            "Pear": "Poire",
            "Hourglass": "Sablier",
            "Normal": "Normal",
            "Underweight": "Insuffisance pondérale",
            "Overweight": "Surpoids"
        },
        "chatbot": {
          "avatartitle": "Rencontrez votre coach avatar !",
          "avatardesc": "Personnalisez votre avatar et débloquez des conseils de santé intelligents grâce à un chatbot alimenté par l’IA conçu pour être votre coach personnel.",
          "chat": "Discuter",
          "create": "Créer",
          "name": "Nom...",
          "edit": "Modifier",
          "NEXT": "SUIVANT",
          "overlayText": "Félicitations ! Vous avez créé votre propre coach.",
          "inittext1": "Appuyez sur la flèche et entrez sous les projecteurs",
          "inittext2": "Votre voyage avec un coach personnel commence maintenant !"
        },
          "footer": {
              "title": "Questions ou clarifications ? Envoyez-nous un e-mail !",
              "desc": "Pour des demandes, de l'aide ou des clarifications, n'hésitez pas à nous contacter par e-mail. L'équipe Wellbe est là pour vous soutenir dans votre parcours.",
              "submit": "Soumettre",
              "copyright": "Droits d'auteur © Wellbe. Tous droits réservés",
              "FAQ": "FAQ",
              "Blog": "Blog",
              "terms": "Termes et conditions",
              "emailPlaceholder": "Email :",
              "messagePlaceholder": "Message",
              "invalidemail": "Format d'e-mail invalide",
              "unsubscribe": "Se désabonner",
          },
          "incorrect": "Incorrect",
          "terms":{
            "title":"Conditions Générales ",
            "text": "Si vous avez des conditions médicales ou envisagez de commencer un programme d'exercices ou de vous engager dans une activité physique ou mentale intense ou inhabituelle, vous devriez d'abord consulter votre médecin. SANS LIMITATION D'AUCUNE AUTRE CONDITION DANS CES CONDITIONS DE SERVICE, WELLBE PRIME NE FAIT AUCUNE REPRÉSENTATION OU GARANTIE QUE LES VIDÉOS SONT DESTINÉES À ET / OU DIAGNOSTIQUENT, TRAITENT, GUÉRISSENT OU PRÉVIENNENT DES ALLERGIES OU AUTRES TROUBLES OU CONDITIONS MÉDICAUX, ET VOUS RECONNAISSEZ PAR LA PRÉSENTE CET AVIS DE NON-RESPONSABILITÉ ET QUE WELLBE PRIME N'EST PAS ENGAGÉE DANS LA FOURNITURE D'UN DISPOSITIF MÉDICAL, DE CONSEILS MÉDICAUX ET / OU DE SERVICES DE SOINS DE SANTÉ EN VOUS DONNANT ACCÈS AUX VIDÉOS. Vous devriez consulter un professionnel de la santé ou du fitness agréé si vous avez des questions concernant votre condition physique ou votre routine de santé mentale. Wellbe Prime n'est en aucun cas responsable des problèmes de santé ou des blessures, y compris, sans limitation, l'incapacité ou la mort, qui pourraient résulter de votre utilisation ou de votre incapacité à utiliser les Vidéos. Wellbe Prime n'est pas un fournisseur de soins de santé ou de dispositifs médicaux, et les Vidéos de Caravan ne doivent pas être considérées comme des conseils médicaux. Wellbe Prime ne fait aucune déclaration, représentation ou garantie que les Vidéos offrent un bénéfice thérapeutique. Toutes les informations médicales et les liens liés aux Vidéos sont fournis simplement pour votre commodité. Tous les conseils ou autres documents dans les Vidéos sont destinés à des fins d'information générale uniquement. Ils ne sont pas destinés à être utilisés et ne doivent pas être considérés comme un substitut à des conseils médicaux ou mentaux professionnels basés sur votre condition et vos circonstances individuelles. Les conseils et autres documents disponibles chez Wellbe Prime sont destinés à soutenir la relation entre vous et vos prestataires de soins de santé et non à la remplacer. Wellbe Prime n'est pas responsable des conséquences de votre lecture ou de votre réception de tels conseils ou autres documents, car vous assumez l'entière responsabilité de vos décisions et actions. En particulier, dans toute la mesure permise par la loi, Wellbe Prime ne fait aucune déclaration ou garantie quant à l'exactitude, l'exhaustivité ou la pertinence à quelque fin que ce soit des informations publiées dans le cadre des Vidéos."
          }
      }
  },
  de:{
      "translation":{
        "landing": {
        "title": "Wellbe",
        "description": "Steigern Sie Ihr Wohlbefinden mit Premium-Inhalten, Expertenberatung und KI-gestützten Einblicken"
        },
        "nav": {
        "sign_out": "Abmelden",
        "sign_in": "Jetzt mitmachen",
        "CalculateIBW": "Wellbe Ai",
        "about": "Über uns",
        "categories": "Videos",
        "keyfigures": "Schlüsselzahlen",
        "mycoach": "Mein Coach",
        "dailyplan": "Tagesplan"
        },
        "about": {
        "title": "Über Wellbe",
        "description": "Wellbe ist Ihre Anlaufstelle für Premium-Inhalte, die darauf abzielen, Ihr Wohlbefinden zu verbessern. Angetrieben von KI-gestützten Einblicken, unterstützt durch Expertenberatung und fundiert auf wissenschaftlicher Forschung, bietet unsere Plattform eine Vielzahl ansprechender und visuell ansprechender Ressourcen.",
        "card-1-desc": "Lebensverändernde Programme, Top-Experten, Bewährte Ergebnisse",
        "card-2-desc": "Hochwertige Videos, mehrsprachige Inhalte, erstklassige Produktion"
        },
        "articles": {
        "title": "Schlüsselzahlen",
        "card-1-title": "Stressreduktion",
        "card-1-desc": "Teilnehmer berichteten von einem deutlichen Rückgang des Stressniveaus, nachdem sie unsere Achtsamkeits- und Meditationsvideos in ihre Routine integriert hatten.",
        "card-2-title": "Körperliche Fitness",
        "card-2-desc": "Die Teilnahme an unseren Fitness- und Yoga-Videos führte zu einem um 64% gesteigerten Fitnessniveau bei den Teilnehmern.",
        "card-3-title": "Verbesserte Schlafqualität",
        "card-3-desc": "Unsere auf Schlaf ausgerichteten Videos trugen dazu bei, dass 72% der Mitglieder eine bessere Schlafqualität meldeten, was zu einem gesteigerten allgemeinen Wohlbefinden führte.",
        "card-4-title": "Psychisches Wohlbefinden",
        "card-4-desc": "Über 80% unserer Community-Mitglieder berichteten von einer verbesserten psychischen Gesundheit und nannten verbesserte Konzentration, Klarheit und emotionales Gleichgewicht."
        },
        "categories": {
        "title": "Unsere Kategorien und Videos",
        "health": "Gesundheit",
        "performance": "Leistung",
        "meditation": "Meditation",
        "nutrition": "Ernährung",
        "yoga": "Yoga",
        "fitness":"Fitness",
        "mindfulness":"Achtsamkeit"
        },
        "video": {
          "video-not-found": "Video nicht verfügbar für die Demo!"
        },
        "custommodal": {
          "phonelabel": "Geben Sie Ihre Telefonnummer ein",
          "not_subscriber": "Noch kein Abonnent?",
          "Subscribe": "Abonnieren",
          "otplabel": "OTP eingeben",
          "Verify": "Überprüfen"
        },
        "bodyweight": {
          "title": "Wellbe Ai",
          "text": "Verfolge deine Körper- und Gesundheitswerte",
          "Weight/Kg": "Gewicht/Kg",
          "Height/CM": "Größe/CM",
          "Age": "Alter",
          "Waist": "Taille/cm",
          "Hips": "Hüfte/cm",
          "Hours": "Stunden",
          "Video": "Video",
          "Health": "Gesundheit",
          "Meditation": "Meditation",
          "Nutrition": "Ernährung",
          "Performance": "Leistung",
          "Yoga": "Yoga",
          "WatchVideo": "Video ansehen",
          "Waistdef": "Messen Sie (cm) an der schmalsten Stelle Ihrer Taille, direkt über dem Bauchnabel.",
          "Hipsdef": "Messen Sie um die breiteste Stelle Ihrer Hüften und Ihres Gesäßes.",
          "personform": {
            "label": "Geben Sie Ihre Daten ein",
            "activitylable": "Aktivitätsniveau",
            "activity": {
              "sedentary": "Sesshaft",
              "light": "Leicht",
              "moderate": "Mäßig",
              "active": "Aktiv"
            },
            "stresslable": "Stressniveau",
            "stress": {
              "low": "Niedrig",
              "high": "Hoch"
            },
            "male": "Mann",
            "female": "Frau",
            "dietarylable": "Ernährungsvorlieben",
            "dietaryoptions": {
              "None": "Keine",
              "Vegetarian": "Vegetarisch",
              "Vegan": "Vegan",
              "Gluten-free": "Glutenfrei",
              "Dairy-free": "Laktosefrei",
              "Paleo": "Paleo",
              "Keto": "Keto",
              "Low-carb": "Kohlenhydratarm",
              "Low-fat": "Fettarm",
              "Other": "Andere"
            },
            "sleepinghours": "Schlafstunden",
            "goals": "Gewichtsziele",
            "goalsoptions": {
              "loss": "Abnehmen",
              "maintain": "Halten",
              "gain": "Zunehmen"
            },
            "calculate": "Berechnen"
          },
          "youresult": "Ihre Ergebnisse",
          "kg": "Kg",
          "resulttext": "Ideales Körpergewicht",
          "inkg": "in kg",
          "MACRONUTRIENTS": "Der ideale Anteil an Makronährstoffen",
          "Carbohydrates": "Kohlenhydrate",
          "Fat": "Fett",
          "Protein": "Protein",
          "bmrdesc": "Grundumsatz",
          "water": "Wasser",
          "Guidelines": "Richtlinien",
          "Fitness_Exercises": "Fitnessübungen",
          "Nutritional_Recommendations": "Ernährungsempfehlungen",
          "Hydration": "Hydration",
          "Sleep_Recovery": "Schlaf und Erholung",
          "Stress_Management": "Stressbewältigung",
          "Movement_Incorporation": "Integration von Bewegung",
          "Wellness_Habits": "Wellness-Gewohnheiten",
          "PLeaseFill": "Bitte ausfüllen",
          "PleaseChoose": "Bitte wählen",
          "Day" : "Tag",
          "Apple": "Apfel",
          "Pear": "Birne",
          "Hourglass": "Sanduhr",
          "Normal": "Normal",
          "Underweight": "Untergewicht",
          "Overweight": "Übergewicht"
        },
        "chatbot": {
            "avatartitle": "Lerne deinen Avatar-Coach kennen!",
            "avatardesc": "Passe deinen Avatar an und erhalte intelligente Gesundheitsberatung durch einen KI-gestützten Chatbot, der als dein persönlicher Coach dient.",
            "chat": "Chat",
            "create": "Erstellen",
            "name": "Name...",
            "NEXT": "WEITER",
            "overlayText": "Glückwunsch! Du hast deinen eigenen Coach erstellt.",
            "inittext1": "Tippe auf den Pfeil und tritt ins Rampenlicht",
            "inittext2": "Deine Reise mit deinem persönlichen Coach beginnt jetzt!"
        },
        "footer": {
          "title": "Fragen oder Klärungen? Senden Sie uns eine E-Mail!",
          "desc": "Für Anfragen, Hilfe oder Klarstellungen können Sie uns gerne per E-Mail kontaktieren. Das Wellbe-Team steht Ihnen bei Ihrem Weg zur Seite.",
          "submit": "Absenden",
          "copyright": "Copyright © Wellbe. Alle Rechte vorbehalten",
          "FAQ": "FAQ",
          "Blog": "Blog",
          "terms": "Allgemeine Geschäftsbedingungen",
          "emailPlaceholder": "Email:",
          "messagePlaceholder": "Nachricht",
          "invalidemail": "Ungültiges E-Mail-Format",
          "unsubscribe": "Abbestellen",
        },
        "incorrect": "Falsch",
        "terms": {
          "title": "Allgemeine Geschäftsbedingungen",
          "text": "Wenn Sie medizinische Bedingungen haben oder beabsichtigen, ein Trainingsprogramm zu beginnen oder sich an einer körperlichen oder geistigen intensiven oder ungewöhnlichen Aktivität zu beteiligen, sollten Sie zuerst Ihren Arzt konsultieren. OHNE EINSCHRÄNKUNG IN DIESER NUTZUNGSBEDINGUNGEN, WELLBE PRIME GIBT KEINE DARSTELLUNG ODER GARANTIE, DASS DIE VIDEOS ZUR DIAGNOSE, BEHANDLUNG, HEILUNG ODER VORBEUGUNG VON ALLERGIEN ODER ANDEREN MEDIZINISCHEN BESCHWERDEN ODER ZUSTÄNDEN BESTIMMT SIND, UND SIE ERKENNEN HIERMIT DIESE HAFTUNGSAUSSCHLUSSANZEIGE UND AN, DASS WELLBE PRIME NICHT VERPFLICHTET IST, MEDIZINISCHE GERÄTE, MEDIZINISCHE BERATUNG UND/ODER GESUNDHEITSDIENSTLEISTUNGEN BEREITZUSTELLEN, INDEM SIE DEN ZUGANG ZU DEN VIDEOS ERLAUBEN. Sie sollten einen zugelassenen Gesundheits- oder Fitnessfachmann konsultieren, wenn Sie Fragen zu Ihrem körperlichen Zustand oder Ihrer geistigen Gesundheitsroutine haben. Wellbe Prime haftet in keiner Weise für gesundheitliche Probleme oder Verletzungen, einschließlich, aber nicht beschränkt auf, Unfähigkeit oder Tod, die sich aus Ihrer Nutzung oder Unfähigkeit zur Nutzung der Videos ergeben können. Wellbe Prime ist kein Anbieter von Gesundheitsdienstleistungen oder medizinischen Geräten, und die Videos von Caravan sollten nicht als medizinische Beratung angesehen werden. Wellbe Prime macht keine Aussage, Darstellung oder Gewährleistung, dass die Videos einen therapeutischen Nutzen bieten. Alle medizinischen Informationen und Links zu den Videos werden lediglich zu Ihrer Bequemlichkeit bereitgestellt. Alle Ratschläge oder anderen Dokumente in den Videos sind ausschließlich zu allgemeinen Informationszwecken bestimmt. Sie sind nicht als Ersatz für professionelle medizinische oder geistige Gesundheitsberatung gedacht und sollten nicht als solche betrachtet werden, die auf Ihre individuellen Umstände und Bedingungen basieren. Die bei Wellbe Prime verfügbaren Ratschläge und anderen Dokumente sollen die Beziehung zwischen Ihnen und Ihren Gesundheitsdienstleistern unterstützen und nicht ersetzen. Wellbe Prime übernimmt keine Verantwortung für die Folgen Ihrer Lektüre oder Empfangs solcher Ratschläge oder anderer Dokumente, da Sie die volle Verantwortung für Ihre Entscheidungen und Handlungen tragen. Insbesondere und soweit gesetzlich zulässig, macht Wellbe Prime keine Zusicherungen oder Garantien hinsichtlich der Richtigkeit, Vollständigkeit oder Relevanz der Informationen in den Videos für irgendeinen Zweck."
        }
      }
  },
  ro:{
      "translation": {
        "landing": {
          "title": "Wellbe",
          "description": "Îmbunătățește-ți bunăstarea cu conținut premium, ghidare de specialitate și perspective bazate pe IA"
        },
        "nav": {
          "sign_out": "Deconectare",
          "sign_in": "Înscrie-te acum",
          "CalculateIBW": "Wellbe Ai",
          "about": "Despre",
          "categories": "Videoclipuri",
          "keyfigures": "Date Cheie",
          "mycoach": "Antrenorul Meu",
          "dailyplan": "Plan zilnic"
        },
        "about": {
          "title": "Despre Wellbe",
          "description": "Wellbe este destinația ta principală pentru conținut premium conceput pentru a-ți îmbunătăți bunăstarea. Bazat pe perspective oferite de IA, susținut de ghidare de specialitate și fundamentat pe cercetări științifice, platforma noastră oferă o varietate de resurse atrăgătoare și vizual plăcute.",
          "card-1-desc": "Programe transformatoare de viață, Experți de top, Rezultate dovedite",
          "card-2-desc": "Videoclipuri de înaltă calitate, Conținut multilingv, Producție premium"
        },
        "articles": {
          "title": "Date Cheie",
          "card-1-title": "Reducerea Stresului",
          "card-1-desc": "Participanții au raportat o scădere vizibilă a nivelurilor de stres după incorporarea videoclipurilor noastre de mindfulness și meditație în rutina lor.",
          "card-2-title": "Fitness Fizic",
          "card-2-desc": "Participarea la videoclipurile noastre de fitness și yoga a dus la o creștere de 64% a nivelurilor raportate de fitness fizic printre participanți.",
          "card-3-title": "Calitate Îmbunătățită a Somnului",
          "card-3-desc": "Videoclipurile noastre axate pe somn au contribuit la 72% dintre membri raportând o calitate mai bună a somnului, conducând la o bunăstare generală crescută.",
          "card-4-title": "Bunăstare Mentală",
          "card-4-desc": "Peste 80% dintre membrii comunității noastre au raportat o bunăstare mentală îmbunătățită, menționând o concentrare, claritate și echilibru emoțional mai bune."
        },
        "categories": {
          "title": "Categorii și Videoclipuri",
          "health": "sănătate",
          "performance": "performanță",
          "meditation": "meditație",
          "nutrition": "nutriție",
          "yoga": "yoga"
        },
        "video": {
          "video-not-found": "Videoclipul nu este disponibil pentru demonstrație!"
        },
        "custommodal": {
          "phonelabel": "Introduceți numărul dumneavoastră de telefon",
          "not_subscriber": "Nu sunteți abonat?",
          "Subscribe": "Abonează-te",
          "otplabel": "Introduceți OTP",
          "Verify": "Verifică"
        },
        "bodyweight": {
          "title": "Wellbe Ai",
          "text": "Urmărește-ți parametrii corpului și sănătății",
          "Weight/Kg": "Greutate/Kg",
          "Height/CM": "Înălțime/CM",
          "Age": "Vârstă",
          "Waist": "Talie/cm",
          "Hips": "Șolduri/cm",
          "Hours": "Ore",
          "Video": "Video",
          "Health": "Sănătate",
          "Meditation": "Meditație",
          "Nutrition": "Nutriție",
          "Performance": "Performanță",
          "Yoga": "Yoga",
          "WatchVideo": "Vizionați video",
          "Waistdef": "Măsurați (cm) în jurul celei mai înguste părți a taliei, chiar deasupra buricului.",
          "Hipsdef": "Măsurați în jurul celei mai late părți a șoldurilor și feselor.",
          "personform": {
            "label": "Introduceți Detaliile Dumneavoastră",
            "activitylable": "Nivel de Activitate",
            "activity": {
              "sedentary": "Sedentar",
              "light": "Ușor",
              "moderate": "Moderat",
              "active": "Activ"
            },
            "stresslable": "Nivel de Stres",
            "stress": {
              "low": "Scăzut",
              "high": "Ridicat"
            },
            "male": "Masculin",
            "female": "Feminin",
            "dietarylable": "Preferințe Dietetice",
            "dietaryoptions": {
              "None": "Niciuna",
              "Vegetarian": "Vegetarian",
              "Vegan": "Vegan",
              "Gluten-free": "Fără Gluten",
              "Dairy-free": "Fără Lactate",
              "Paleo": "Paleo",
              "Keto": "Keto",
              "Low-carb": "Scăzut în Carbohidrați",
              "Low-fat": "Scăzut în Grăsimi",
              "Other": "Altceva"
            },
            "sleepinghours": "Ore de Somn",
            "goals": "Obiective de Greutate",
            "goalsoptions": {
              "loss": "Pierderea",
              "maintain": "Menținerea",
              "gain": "Câștigul"
            },
            "calculate": "Calculează"
          },
          "youresult": "Rezultatele Dumneavoastră",
          "kg": "Kg",
          "resulttext": "Greutatea corporală ideală",
          "inkg": "în kg",
          "MACRONUTRIENTS": "Macronutrienții Ideali %",
          "Carbohydrates": "Carbohidrați",
          "Fat": "Grăsimi",
          "Protein": "Proteine",
          "bmrdesc": "Rata metabolică bazală",
          "water": "Apă",
          "Guidelines": "Recomandări",
          "Fitness_Exercises": "Exerciții Fizice",
          "Nutritional_Recommendations": "Recomandări Nutriționale",
          "Hydration": "Hidratare",
          "Sleep_Recovery": "Somn și Recuperare",
          "Stress_Management": "Gestionarea Stresului",
          "Movement_Incorporation": "Incorporarea Mișcării",
          "Wellness_Habits": "Obiceiuri de Bunăstare",
          "PleaseFill": "Vă rugăm să Completați",
          "PleaseChoose": "Vă Rugăm să Alegeți",
          "Day" : "Zi",
          "Apple": "Măr",
          "Pear": "Pară",
          "Hourglass": "Clepsidră",
          "Normal": "Normal",
          "Underweight": "Subponderal",
          "Overweight": "Supraponderal"
        },
        "chatbot": {
          "avatartitle": "Cunoaște-ți antrenorul avatar!",
          "avatardesc": "Personalizează-ți avatarul și descoperă ghidarea inteligentă pentru sănătate cu ajutorul unui chatbot alimentat de inteligență artificială, conceput să fie antrenorul tău personal.",
          "chat": "Chat",
          "create": "Creează",
          "name": "Nume...",
          "edit": "Editează",
          "NEXT": "URMĂTORUL",
          "overlayText": "Felicitări! Ți-ai creat propriul antrenor.",
          "inittext1": "Atinge săgeata și pășește în lumina reflectoarelor",
          "inittext2": "Călătoria ta cu antrenorul personal începe acum!"

        },
        "footer": {
          "title": "Întrebări sau Clarificări? Contactați-ne prin email!",
          "desc": "Pentru întrebări, asistență sau orice clarificări, nu ezitați să ne contactați prin email. Echipa Wellbe este aici pentru a vă sprijini în călătoria dumneavoastră.",
          "submit": "Trimiteți",
          "copyright": "Copyright© Wellbe. Toate drepturile rezervate",
          "FAQ": "Întrebări frecvente",
          "Blog": "Blog",
          "terms": "Termeni și Condiții",
          "emailPlaceholder": "Email:",
          "messagePlaceholder": "Mesaj",
          "invalidemail": "Format email invalid",
          "unsubscribe": "Dezabonare",
        },
        "incorrect": "Incorect",
        "terms": {
          "title": "Termeni și Condiții",
          "text": "Dacă aveți condiții medicale sau vă gândiți să începeți un program de exerciții sau să vă angajați în activități fizice sau mentale neobișnuite sau solicitante, ar trebui să consultați mai întâi medicul dumneavoastră. FĂRĂ LIMITAREA ORICĂROR ALTOR TERMENI ÎN ACEST DOCUMENT DE SERVICIU, WELLBE PRIME NU FACE NICIO REPREZENTARE SAU GARANȚIE CĂ VIDEOCIPILURILE SUNT DESTINATE ȘI/SAU NU DIAGNOSTICĂ, TRATEAZĂ, CUREAZĂ SAU PREVINE NICIO ALERGIE SAU ALTE AFECȚIUNI SAU CONDIȚII MEDICALE, ȘI PRIN PREZENT RECUNOAȘTEȚI ACEST DECLINARE ȘI CĂ WELLBE PRIME NU ESTE IMPLICAT ÎN OFERIREA DE DISPOZITIVE MEDICALE, SFATURI MEDICALE ȘI/SAU SERVICII DE SĂNĂTATE PRIN OFERIREA ACCESULUI LA VIDEOCIPILURI. Ar trebui să consultați un profesionist medical sau de fitness licențiat dacă aveți întrebări legate de rutina dumneavoastră de fitness fizic sau de sănătate mentală. Wellbe Prime nu este responsabil în niciun fel pentru problemele de sănătate sau leziunile, inclusiv, fără a se limita la incapacitate sau deces, care pot rezulta din sau sunt legate de utilizarea sau incapacitatea de a utiliza Videocipurile. Wellbe Prime nu este un furnizor de îngrijire medicală sau dispozitive medicale și nici Videocipurile Caravan nu ar trebui considerate sfaturi medicale. Wellbe Prime nu face niciun fel de afirmații, reprezentări sau garanții că Videocipurile oferă un beneficiu terapeutic. Orice informații de sănătate și linkuri legate de Videocipuri sunt oferite doar pentru confortul dumneavoastră. Orice sfaturi sau alte materiale din Videocipuri sunt destinate exclusiv pentru scopuri generale informative. Nu sunt destinate să fie utilizate ca substitut pentru sfaturi medicale sau mentale profesionale bazate pe condiția și circumstanțele dumneavoastră individuale. Sfaturile și alte materiale disponibile de Wellbe Prime sunt menite să susțină relația dintre dumneavoastră și furnizorii dumneavoastră de îngrijire medicală și nu să o înlocuiască. Wellbe Prime nu este responsabilă sau răspunzătoare pentru orice consecințe ale citirii sau informării despre aceste sfaturi sau alte materiale, întrucât vă asumați întreaga responsabilitate pentru deciziile și acțiunile dumneavoastră. În special, în cea mai mare măsură permisă de lege, Wellbe Prime nu face nicio reprezentare sau garanție despre acuratețea, completitudinea sau adecvarea pentru orice scop a informațiilor publicate ca parte a Videocipurilor."
        }
      }
  },
  pl:{
      "translation": {
          "landing": {
              "title": "Wellbe",
              "description": "Podnieś swoje samopoczucie dzięki treściom premium, fachowemu doradztwu i wglądowi wspomaganemu przez AI"
          },
          "nav": {
              "sign_out": "Wyloguj się",
              "sign_in": "Dołącz teraz",
              "CalculateIBW": "Wellbe AI",
              "about": "O nas",
              "categories": "Wideo",
              "keyfigures": "Kluczowe dane",
              "mycoach": "Mój Trener",
              "dailyplan": "Plan dzienny"
          },
          "about": {
              "title": "O Wellbe",
              "description": "Wellbe to twoje główne źródło treści premium zaprojektowanych, aby poprawić twoje samopoczucie. Dzięki wglądowi wspomaganemu przez AI, wspieranemu fachowym doradztwem i opartego na badaniach naukowych, nasza platforma oferuje różnorodne, angażujące i wizualnie atrakcyjne zasoby.",
              "card-1-desc": "Programy zmieniające życie, najlepsi eksperci, sprawdzone rezultaty",
              "card-2-desc": "Wysokiej jakości wideo, treści wielojęzyczne, produkcja premium"
          },
          "articles": {
              "title": "Kluczowe dane",
              "card-1-title": "Redukcja stresu",
              "card-1-desc": "Uczestnicy zgłosili zauważalny spadek poziomu stresu po wprowadzeniu naszych wideo z medytacją i uważnością do swojej rutyny",
              "card-2-title": "Kondycja fizyczna",
              "card-2-desc": "Zaangażowanie w nasze wideo z ćwiczeniami i jogą doprowadziło do 64% wzrostu zgłoszonej kondycji fizycznej wśród uczestników",
              "card-3-title": "Poprawa jakości snu",
              "card-3-desc": "Nasze wideo skoncentrowane na śnie przyczyniły się do tego, że 72% członków zgłosiło lepszą jakość snu, co prowadziło do poprawy ogólnego samopoczucia",
              "card-4-title": "Zdrowie psychiczne",
              "card-4-desc": "Ponad 80% członków naszej społeczności zgłosiło poprawę zdrowia psychicznego, zauważając lepszą koncentrację, klarowność i równowagę emocjonalną"
          },
          "categories": {
              "title": "Nasze kategorie i wideo",
              "health": "zdrowie",
              "performance": "wydajność",
              "meditation": "medytacja",
              "nutrition": "odżywianie",
              "yoga": "joga"
          },
          "video": {
              "video-not-found": "Wideo niedostępne do demonstracji!"
          },
          "custommodal": {
              "phonelabel": "Wpisz swój numer telefonu",
              "not_subscriber": "Nie jesteś subskrybentem?",
              "Subscribe": "Subskrybuj",
              "otplabel": "Wpisz kod OTP",
              "Verify": "Zweryfikuj"
          },
          "bodyweight": {
              "title": "Wellbe AI",
              "text": "Śledź parametry swojego ciała i zdrowia",
              "Weight/Kg": "Waga/Kg",
              "Height/CM": "Wzrost/CM",
              "Age": "Wiek",
              "Waist": "Talia/cm",
              "Hips": "Biodra/cm",
              "Hours": "Godziny",
              "Video": "Wideo",
              "Health": "Zdrowie",
              "Meditation": "Medytacja",
              "Nutrition": "Odżywianie",
              "Performance": "Wydajność",
              "Yoga": "Joga",
              "WatchVideo": "Oglądaj wideo",
              "Waistdef": "Zmierz (cm) w najwęższym miejscu talii, tuż nad pępkiem.",
              "Hipsdef": "Zmierz najszerszą część bioder i pośladków.",
              "personform": {
                  "label": "Wpisz swoje dane",
                  "activitylable": "Poziom aktywności",
                  "activity": {
                      "sedentary": "Siedzący tryb życia",
                      "light": "Lekki",
                      "moderate": "Umiarkowany",
                      "active": "Aktywny"
                  },
                  "stresslable": "Poziom stresu",
                  "stress": {
                      "low": "Niski",
                      "high": "Wysoki"
                  },
                  "male": "Mężczyzna",
                  "female": "Kobieta",
                  "dietarylable": "Preferencje dietetyczne",
                  "dietaryoptions": {
                      "None": "Brak",
                      "Vegetarian": "Wegetariańska",
                      "Vegan": "Wegańska",
                      "Gluten-free": "Bezglutenowa",
                      "Dairy-free": "Bez nabiału",
                      "Paleo": "Paleo",
                      "Keto": "Keto",
                      "Low-carb": "Niskowęglowodanowa",
                      "Low-fat": "Niskotłuszczowa",
                      "Other": "Inne"
                  },
                  "sleepinghours": "Godziny snu",
                  "goals": "Cele wagowe",
                  "goalsoptions": {
                      "loss": "Schudnąć",
                      "maintain": "Utrzymać",
                      "gain": "Przytyć"
                  },
                  "calculate": "Oblicz"
              },
              "youresult": "Twoje wyniki",
              "kg": "Kg",
              "resulttext": "Idealna masa ciała",
              "inkg": "w kg",
              "MACRONUTRIENTS": "Idealne makroskładniki %",
              "Carbohydrates": "Węglowodany",
              "Fat": "Tłuszcz",
              "Protein": "Białko",
              "bmrdesc": "Podstawowa przemiana materii",
              "water": "Woda",
              "Guidelines": "Wytyczne",
              "Fitness_Exercises": "Ćwiczenia fitness",
              "Nutritional_Recommendations": "Zalecenia żywieniowe",
              "Hydration": "Nawodnienie",
              "Sleep_Recovery": "Sen i regeneracja",
              "Stress_Management": "Zarządzanie stresem",
              "Movement_Incorporation": "Włączenie ruchu",
              "Wellness_Habits": "Nawyki wellness",
              "PleaseFill": "Proszę wypełnić",
              "PleaseChoose": "Proszę wybrać",
              "Day" : "Dzień",
              "Apple": "Jabłko",
              "Pear": "Gruszka",
              "Hourglass": "Klepsydra",
              "Normal": "Normalny",
              "Underweight": "Niedowaga",
              "Overweight": "Nadwaga"
          },
          "chatbot": {
            "avatartitle": "Poznaj swojego awatara trenera!",
            "avatardesc": "Dostosuj swojego awatara i odblokuj inteligentne porady zdrowotne dzięki chatbotowi opartemu na sztucznej inteligencji, który stanie się twoim osobistym trenerem.",
            "chat": "Czat",
            "create": "Utwórz",
            "name": "Imię...",
            "edit": "Edytuj",
            "NEXT": "DALEJ",
            "overlayText": "Gratulacje! Stworzyłeś własnego trenera.",
            "inittext1": "Stuknij strzałkę i wejdź w centrum uwagi",
            "inittext2": "Twoja podróż z osobistym trenerem zaczyna się teraz!"
          },
          "footer": {
              "title": "Pytania lub wyjaśnienia? Napisz do nas!",
              "desc": "W przypadku pytań, pomocy lub jakichkolwiek wyjaśnień, prosimy o kontakt za pośrednictwem e-maila. Zespół Wellbe jest tutaj, aby wspierać cię w twojej podróży",
              "submit": "Prześlij",
              "copyright": "Copyright© Wellbe. Wszelkie prawa zastrzeżone",
              "FAQ": "FAQ",
              "Blog": "Blog",
              "terms": "Warunki i zasady",
              "emailPlaceholder": "E-mail:",
              "messagePlaceholder": "Wiadomość",
              "invalidemail": "Nieprawidłowy format e-maila",
              "unsubscribe": "Anuluj subskrypcję"
          },
          "incorrect": "Niepoprawne",
          "terms": {
              "title": "Warunki i zasady",
              "text": "Jeśli masz jakiekolwiek problemy zdrowotne lub myślisz o rozpoczęciu programu ćwiczeń lub zaangażowaniu się w intensywną lub nietypową aktywność fizyczną lub psychiczną, powinieneś najpierw skonsultować się z lekarzem. BEZ OGRANICZENIA JAKICHKOLWIEK INNYCH WARUNKÓW W NINIEJSZYCH WARUNKACH ŚWIADCZENIA USŁUG, WELLBE PRIME NIE SKŁADA ŻADNYCH OŚWIADCZEŃ ANI GWARANCJI, ŻE WIDEO SĄ PRZEZNACZONE DO DIAGNOZOWANIA, LECZENIA, LECZENIA LUB ZAPOBIEGANIA JAKIMKOLWIEK ALERGIOM LUB INNYM ZABURZENIOM LUB STANOM MEDYCZNYM, I TYM SAMYM PRZYZNAJESZ SIĘ DO TEGO OŚWIADCZENIA I PRZYJMUJESZ DO WIADOMOŚCI, ŻE WELLBE PRIME NIE ŚWIADCZY USŁUG MEDYCZNYCH, PORAD ZDROWOTNYCH I/LUB USŁUG OPIEKI ZDROWOTNEJ POPRZEZ UDOSTĘPNIANIE DOSTĘPU DO WIDEO. Powinieneś skonsultować się z licencjonowanym specjalistą medycznym lub fitness, jeśli masz jakiekolwiek pytania dotyczące swojej rutyny fizycznej lub zdrowia psychicznego. Wellbe Prime nie ponosi odpowiedzialności w jakikolwiek sposób za jakiekolwiek problemy zdrowotne lub urazy, w tym, bez ograniczeń, niezdolność lub śmierć, które mogą wyniknąć z lub być związane z twoim korzystaniem z lub niemożnością korzystania z Wideo. Wellbe Prime nie jest dostawcą urządzeń medycznych ani usług medycznych, a Wideo Caravan nie powinny być uznawane za poradę medyczną. Wellbe Prime nie składa żadnych roszczeń, oświadczeń ani gwarancji, że Wideo zapewnia korzyść terapeutyczną. Jakiekolwiek informacje zdrowotne i linki związane z Wideo są podawane wyłącznie dla twojej wygody. Wszelkie porady lub inne materiały zawarte w Wideo mają na celu dostarczenie ogólnych informacji i nie są przeznaczone do zastąpienia profesjonalnej porady medycznej lub zdrowotnej opartej na twojej indywidualnej sytuacji i warunkach. Porady i inne materiały udostępniane przez Wellbe Prime mają na celu wsparcie relacji między tobą a twoimi dostawcami opieki zdrowotnej, a nie ich zastąpienie. Wellbe Prime nie ponosi odpowiedzialności ani nie odpowiada za jakiekolwiek konsekwencje wynikające z przeczytania lub otrzymania takiej porady lub innych materiałów, gdyż bierzesz pełną odpowiedzialność za swoje decyzje i działania. W szczególności, w maksymalnym zakresie dozwolonym przez prawo, Wellbe Prime nie składa żadnych oświadczeń ani gwarancji dotyczących dokładności, kompletności lub przydatności informacji opublikowanych w ramach Wideo."
          }
      }
  }
  
  
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
    },
    interpolation: {
      escapeValue: false,
    },
  });
export default i18n;